import { useMemo } from "react"
import Select from "~/ui-rtk/components/ui/controls/Select"
import {
  type AssignableUser,
  useAssignableUsers,
} from "../hooks/useAssignableUsers"

const UNASSIGNED = ""

function optionLabel(user: AssignableUser) {
  if (user.isSelf) return `${user.name} (me)`
  if (user.isExternalSuperAdmin) return `${user.name} (Super admin)`
  return user.name
}

/**
 * Dropdown of assignable users for an agenda slot: company members, plus all
 * super admins when the logged-in user is a super admin.
 */
export default function AssigneePicker({
  value,
  onChange,
}: {
  value?: string | null
  onChange: (assigneeId: string | null) => void
}) {
  const { users, isLoading } = useAssignableUsers()

  const options = useMemo(
    () => [
      { value: UNASSIGNED, label: "Unassigned" },
      ...users.map(user => ({
        value: user.id,
        label: optionLabel(user),
      })),
    ],
    [users],
  )

  return (
    <Select
      options={options}
      value={value ?? UNASSIGNED}
      disabled={isLoading}
      onChange={e =>
        onChange(e.target.value === UNASSIGNED ? null : e.target.value)
      }
    />
  )
}
